import { render, staticRenderFns } from "./expelList.vue?vue&type=template&id=40eac5d4&scoped=true&"
import script from "./expelList.vue?vue&type=script&lang=js&"
export * from "./expelList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40eac5d4",
  null
  
)

export default component.exports